export const ActionTypes = {
  LOADING: "DELETE_ROLES_LOADING",
  ERROR: "DELETE_ROLES_ERROR",
  SUCCESS: "DELETE_ROLES_SUCCESS",
};
